import React, { useContext } from "react"
import styled from "styled-components"
import Slider from "react-slick"
import ReactPlayer from "react-player"
import { UIContext } from "../../../components/shared/layout"

import {
  LightboxWrapper,
  LightboxControls,
  LightboxContentWrapper,
} from "./lightbox.styles"

const VideoWrapper = styled.div`
  position: relative;

  padding-top: clamp(
    0px,
    calc(100% / (${props => props.videoWidth} / ${props => props.videoHeight})),
    min(75vh, calc(${props => props.videoHeight / props.videoWidth} * 100%))
  );

  width: clamp(
    0px,
    calc(
      (
          ${props =>
            props.videoHeight > props.videoWidth
              ? props.videoHeight / props.videoWidth
              : props.videoWidth / props.videoHeight}
        ) * 100%
    ),
    calc(75vh * ${props => props.videoWidth / props.videoHeight})
  );

  & > * {
    position: absolute;
    top: 0;
    left: 0;
  }
`

export const DefaultPlayerProps = {
  controls: true,
  playingmuted: "true",
  playsinline: true,
  playing: true,
}

const VideoLightbox = ({
  toggle,
  videoUrl,
  videoWidth = 640,
  videoHeight = 480,
  playerProps = DefaultPlayerProps,
}) => {
  return (
    <LightboxWrapper>
      <LightboxControls>
        <button onClick={() => toggle()}>Close</button>
      </LightboxControls>
      <LightboxContentWrapper onClick={() => toggle()}>
        <VideoWrapper
          videoWidth={videoWidth}
          videoHeight={videoHeight}
          videoAspect={videoWidth / videoHeight}
          onClick={e => {
            e.stopPropagation()
          }}
        >
          <ReactPlayer
            width={"100%"}
            height={"100%"}
            url={videoUrl}
            {...playerProps}
          />
        </VideoWrapper>
      </LightboxContentWrapper>
    </LightboxWrapper>
  )
}

export default VideoLightbox
